import { lazy } from "react";

const routes = [
  {
    path: "/application",
    element: lazy(() => import("../../pages/Saas/Applications")),
  },
  {
    path: "/application/create",
    element: lazy(
      () => import("../../pages/Saas/Applications/create-editApplication"),
    ),
  },
  {
    path: "/application/edit/:id",
    element: lazy(
      () => import("../../pages/Saas/Applications/create-editApplication"),
    ),
  },
];

export default routes;
